type TagsResolveCtx = {
    tags: {
        props: Record<string, string>
    }[]
}

export const tagsResolveHook = (ctx: TagsResolveCtx) => {
    const alternateLinks = new Map()

    ctx.tags.forEach((tag) => {
        if (tag.props.rel === 'alternate') {
            alternateLinks.set(tag.props.hreflang, tag)
        }
        if (tag.props.rel === 'canonical') {
            alternateLinks.set('canonical', tag)
        }
    })

    ctx.tags = ctx.tags.filter((tag) => {
        if (tag.props.rel === 'alternate') {
            return alternateLinks.get(tag.props.hreflang) === tag
        }
        if (tag.props.rel === 'canonical') {
            return alternateLinks.get('canonical') === tag
        }
        return true
    })
}
